module.exports = __webpack_public_path__ + "static/media/signal-slash.fbc1cb61.svg";